import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { GlobalContext } from '../../context/Provider';
import { toast } from 'react-toastify';
import Spinner from './spinner';

const ProtectedRoute = ({ children }: { children?: React.ReactNode }) => {
    const { authState, profileFetchCompleted } = useContext(GlobalContext);

    if (!profileFetchCompleted && authState?.is_admin_verified === 'pending') {
        return <div className='d-flex justify-content-center align-items-center vh-100'><Spinner color="text-success" /></div>;
    }

    if (authState?.is_admin_verified === 'pending') {
        toast.error("Your account is pending for admin verification.");
        return <Navigate to="/" replace />;
    }

    if (authState?.is_admin_verified === 'reject') {
        toast.error("Your account is rejected for admin verification.");
        return <Navigate to="/" replace />;
    }

    return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;
